import { render, staticRenderFns } from "./Tmbn.vue?vue&type=template&id=15a49d39&"
import script from "./Tmbn.vue?vue&type=script&lang=js&"
export * from "./Tmbn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports